<template>
<div class="main">
  <FormHero :formtype="'shortlist'" :stage="'aboutyou'" :agentdata="[]"></FormHero>

  <div class="container ut-px-4">

    <vue-form :state="formstate">

      <validate auto-label class="form-group required-field ut-mb-2" :class="fieldClassName(formstate.name)">

        <input type="text" v-gaEvent="{ category: gacategory, action: 'Click Name Field', label: ''}" placeholder="Full name *" name="name" class="form-control" required v-model.lazy="model.name">

        <field-messages name="name" show="$touched || $submitted" class="form-control-feedback">
          <div slot="required">Name is a required field</div>
        </field-messages>

      </validate>

      <validate auto-label class="form-group required-field ut-mb-2" :class="fieldClassName(formstate.email)">

        <input type="email" v-gaEvent="{ category: gacategory, action: 'Click Email Field', label: ''}" placeholder="Email *" name="email" class="form-control" required v-model.lazy="model.email">

        <field-messages auto-label name="email" show="$touched || $submitted" class="form-control-feedback">
          <div slot="required">Email is a required field</div>
          <div slot="email">Email is invalid</div>
        </field-messages>

      </validate>

      <validate auto-label class="form-group required-field ut-mb-2" :class="fieldClassName(formstate.phone)">

        <input v-gaEvent="{ category: gacategory, action: 'Click Phone Field', label: ''}" type="tel" placeholder="Phone number *" name="phone" class="form-control" required pattern="^(?:\+?(61))? ?(?:\((?=.*\)))?(0?[2-57-8])\)? ?(\d\d(?:[- ](?=\d{3})|(?!\d\d[- ]?\d[- ]))\d\d[- ]?\d[- ]?\d{3})$"
          v-model.lazy="model.phone">

        <field-messages name="phone" show="$touched || $submitted" class="form-control-feedback">
          <div slot="required">Phone number is a required field</div>
          <div slot="pattern">Phone number is invalid</div>
        </field-messages>

      </validate>

      <div class="ut-subtext">Your number will not be shared with agents without your consent, and will only be used by our team to gather more information</div>

      <div class="ut-oa-btn ut-mt-8 ut-block" :to="{name: 'Home'}" @click="validate()" v-gaEvent="{ category: gacategory, action: 'Click Get my shortlist', label: ''}">Get my shortlist</div>

      <div class="ut-subtext ut-pt-8">By submitting this information, you agree to our <a class="ut-underline" href="https://www.openagent.com.au/terms" target="_blank">Terms and Services</a></div>
    </vue-form>
  </div>
</div>
</template>

<script>
import axios from 'axios';
import qs from 'qs';
import FormHero from '@/components/FormHero.vue';
import Vue from 'vue';
import VueForm from 'vue-form';
import indigoHelpers from '../helpers/indigo-helpers';

Vue.use(VueForm, {
  inputClasses: {
    valid: 'form-control-success',
    invalid: 'form-control-danger',
  },
});

export default {
  name: 'PersonalisedShortlistStep2',
  props: {
    gaaction: null,
    galabel: null,
  },
  components: {
    FormHero,
  },

  data() {
    return {
      gacategory: 'Personalised Short List Form',
      formstate: {},
      model: {
        name: '',
        email: '',
        phone: '',
        department: null,
        comments: '',
        notValidated: '',
        agree: false,
      },
      name: null,
      email: null,
      phone: null,
      storedInteractionKey: null,
      storedLeadKey: null,
      errors: [],
    };
  },
  methods: {
    fieldClassName(field) {
      if (!field) {
        return '';
      }
      if ((field.$touched || field.$submitted) && field.$valid) {
        return 'hasSuccess';
      }
      if ((field.$touched || field.$submitted) && field.$invalid) {
        return 'hasDanger';
      }
    },
    validate() {
      this.formstate.$submitted = true;

      const storeshortlistdata = this.$store.state.shortlistdata;

      if (this.formstate.$valid) {
        storeshortlistdata.name = this.model.name;
        storeshortlistdata.email = this.model.email;
        storeshortlistdata.phone = this.model.phone;

        console.log(storeshortlistdata);

        // const formData = new FormData();
        //
        // formData.append('name', storeshortlistdata.name);
        // formData.append('email', storeshortlistdata.email);
        // formData.append('phone', storeshortlistdata.phone);
        // formData.append('propertytype', storeshortlistdata.reasonforsale);
        // formData.append('expectedsalepricehigh', storeshortlistdata.pricerange);
        // formData.append('expecttosell', storeshortlistdata.sellingtime);
        //
        // formData.append('be', storeshortlistdata.address.details.beds);
        // formData.append('streetaddress', storeshortlistdata.address.details.streetaddress);
        // formData.append('suburb', storeshortlistdata.address.details.suburb);
        // formData.append('state', storeshortlistdata.address.details.state);
        // formData.append('postcode', storeshortlistdata.address.details.postcode);
        // formData.append('latitude', storeshortlistdata.address.details.latitude);
        // formData.append('longitude', storeshortlistdata.address.details.longitude);
        // name=test&email=test%40test.com&formname=add-lead-web

        const data = {
          name: storeshortlistdata.name,
          email: storeshortlistdata.email,
          phone: storeshortlistdata.phone,
          streetaddress: storeshortlistdata.streetaddress,
          propertytype: (storeshortlistdata.addressdata.details != undefined ? storeshortlistdata.addressdata.details.propertytype : null),
          reasonforsale: storeshortlistdata.reasonforsale,
          expectedsalepricehigh: storeshortlistdata.highpricerange,
          expectedsalepricelow: storeshortlistdata.lowpricerange,
          expecttosell: storeshortlistdata.sellingtime,
          be: (storeshortlistdata.addressdata.details != undefined ? storeshortlistdata.addressdata.details.beds : null),
          streetaddress: storeshortlistdata.streetaddress,
          latitude: (storeshortlistdata.addressdata.details != undefined ? storeshortlistdata.addressdata.details.latitude : storeshortlistdata.addressdata.latitude),
          longitude: (storeshortlistdata.addressdata.details != undefined ? storeshortlistdata.addressdata.details.longitude : storeshortlistdata.addressdata.longitude),
          rpdataid: (storeshortlistdata.addressdata.details != undefined ? storeshortlistdata.addressdata.id : null),
          st: (storeshortlistdata.addressdata.details != undefined ? storeshortlistdata.addressdata.details.state : storeshortlistdata.addressdata.state),
          su: (storeshortlistdata.addressdata.details != undefined ? storeshortlistdata.addressdata.details.suburb : storeshortlistdata.addressdata.suburb),
          dialleractiontypeid: 2,
          formname: 'add-lead-web',
          ch: 59,
          brand: 'OpenAgent',
          call: 1,
          postcode: (storeshortlistdata.addressdata.details != undefined ? storeshortlistdata.addressdata.details.postcode : storeshortlistdata.addressdata.postcode),
          postcodeid: storeshortlistdata.postcodeid,
        };

        console.log(data);

        let storedInteractionKey;
        let storedLeadKey;
        let router = this.$router;
        let store = this.$store;

        indigoHelpers.createInteraction(data).then((res) => {

          storedInteractionKey = res.key;

          indigoHelpers.createLeadForInteraction(data, storedInteractionKey).then((res) => {

            storedLeadKey = res.key;

            window.location = `${process.env.VUE_APP_OA_URL}/contact-agents/?lk=${storedLeadKey}`;

            // router.push({
            //   name: 'Home',
            //   query: store.state.query
            // });

          }).catch((error) => {
            console.log(error);
          });

        }).catch((error) => {
          console.log(error);
        });

      }
    },
  },

  created() {
    if (this.$store.state.shortlistdata == undefined) {
      this.$router.push({
        path: '/shortlist/step1',
      });
    }
  },
};
</script>

<style scoped lang="scss">
.main {
    max-width: 600px;
    margin: 0 auto;
}
</style>
